import { ValueFormatNumber, ValueFormatText, ValueFormatType } from './value-format';

export const FN_COMMERCIAL_STEEL_GRADE_ID = 'commercialSteelGradeID';
export const FN_LENGTH_UNIT = 'lengthUnit';
export const FN_LENGTH_VALUE = 'lengthValue';
export const FN_THICKNESS_UNIT = 'thicknessUnit';
export const FN_THICKNESS_VALUE = 'thicknessValue';
export const FN_WIDTH_UNIT = 'widthUnit';
export const FN_WIDTH_VALUE = 'widthValue';

const FORMAT_A10: ValueFormatText = { type: ValueFormatType.TYPE_TEXT, length: 10 };
const FORMAT_A12: ValueFormatText = { type: ValueFormatType.TYPE_TEXT, length: 12 };
const FORMAT_N2: ValueFormatNumber = { type: ValueFormatType.TYPE_NUMBER, lengthInteger: 2, decimalCount: 0 };
const FORMAT_N3: ValueFormatNumber = { type: ValueFormatType.TYPE_NUMBER, lengthInteger: 3, decimalCount: 0 };
const FORMAT_N4: ValueFormatNumber = { type: ValueFormatType.TYPE_NUMBER, lengthInteger: 4, decimalCount: 0 };
const FORMAT_A17: ValueFormatText = { type: ValueFormatType.TYPE_TEXT, length: 17 };
const FORMAT_N5_1: ValueFormatNumber = { type: ValueFormatType.TYPE_NUMBER, lengthInteger: 5, decimalCount: 1 };
const FORMAT_N6: ValueFormatNumber = { type: ValueFormatType.TYPE_NUMBER, lengthInteger: 6, decimalCount: 0 };
const FORMAT_N5_4: ValueFormatNumber = { type: ValueFormatType.TYPE_NUMBER, lengthInteger: 5, decimalCount: 4 };
const FORMAT_N2_1: ValueFormatNumber = { type: ValueFormatType.TYPE_NUMBER, lengthInteger: 2, decimalCount: 1 };
const FORMAT_N3_2: ValueFormatNumber = { type: ValueFormatType.TYPE_NUMBER, lengthInteger: 3, decimalCount: 2 };
const FORMAT_A1: ValueFormatText = { type: ValueFormatType.TYPE_TEXT, length: 1 };
const FORMAT_A3: ValueFormatText = { type: ValueFormatType.TYPE_TEXT, length: 3 };
const FORMAT_A5: ValueFormatText = { type: ValueFormatType.TYPE_TEXT, length: 5 };
const FORMAT_A6: ValueFormatText = { type: ValueFormatType.TYPE_TEXT, length: 6 };
const FORMAT_A9: ValueFormatText = { type: ValueFormatType.TYPE_TEXT, length: 9 };
const FORMAT_A60: ValueFormatText = { type: ValueFormatType.TYPE_TEXT, length: 60 };
const FORMAT_A30: ValueFormatText = { type: ValueFormatType.TYPE_TEXT, length: 30 };

const FORMAT_BY_FIELD: Record<string, ValueFormatText | ValueFormatNumber> = {
	a2citemNumber: FORMAT_A12,
	a2citemRelease: FORMAT_N3,
	additionalTest: FORMAT_A3,
	addTechnicalPrescription: FORMAT_A3,
	aimedThickness: FORMAT_N5_4,
	averageMinEnergyValue: FORMAT_N3,
	axisOrientationCode: FORMAT_A3,
	baseMaterial: FORMAT_A3,
	betterSidePosition: FORMAT_A3,
	bundleHeightIncludePackaging: FORMAT_A1,
	calciumTreatment: FORMAT_A3,
	coilCoresType: FORMAT_A3,
	commercialCamberToleranceID: FORMAT_A60,
	commercialChemicalSurfaceTreatmentBottomID: FORMAT_A60,
	commercialChemicalSurfaceTreatmentTopID: FORMAT_A60,
	commercialColourBottomID: FORMAT_A60,
	commercialColourTopID: FORMAT_A60,
	commercialFlatnessToleranceID: FORMAT_A60,
	commercialLengthToleranceID: FORMAT_A60,
	commercialMetallicCoatingID: FORMAT_A60,
	commercialOrganicDataSheetNameBottomID: FORMAT_A60,
	commercialOrganicDataSheetNameTopID: FORMAT_A60,
	commercialPatternTypeBottomID: FORMAT_A60,
	commercialPatternTypeTopID: FORMAT_A60,
	commercialRoughnessTopID: FORMAT_A60,
	commercialSpangleTopID: FORMAT_A60,
	commercialSquarenessToleranceID: FORMAT_A60,
	commercialSteelGradeID: FORMAT_A60,
	commercialStrippableFilmTypeBottomID: FORMAT_A60,
	commercialStrippableFilmTypeTopID: FORMAT_A60,
	commercialSurfaceClassificationBottomID: FORMAT_A60,
	commercialSurfaceClassificationTopID: FORMAT_A60,
	commercialThicknessToleranceID: FORMAT_A60,
	commercialTOCTypeBottomID: FORMAT_A60,
	commercialTOCTypeTopID: FORMAT_A60,
	commercialTransversalProfileToleranceID: FORMAT_A60,
	commercialWidthToleranceID: FORMAT_A60,
	configurationNumber: FORMAT_A10,
	configurationRelease: FORMAT_N3,
	customerArticleContent: FORMAT_A3,
	customerArticleDetailledDesignationFreeText: FORMAT_A30,
	customerArticleDiameter: FORMAT_N4,
	customerArticleForm: FORMAT_A3,
	customerArticleHeight: FORMAT_N4,
	customerArticleMaxDiameterAfterExpansion: FORMAT_N4,
	customerArticleTypeOfContent: FORMAT_A3,
	customerArticleVolume: FORMAT_A3,
	customerExpansionTechnique: FORMAT_A3,
	customerFlangingTechnique: FORMAT_A3,
	customerTechnicalSpecificationCode: FORMAT_A6,
	customerTemplateNumber: FORMAT_A10,
	customerTemplateReference: FORMAT_A30,
	customerTemplateRelease: FORMAT_N3,
	defectTrackingRequested: FORMAT_A1,
	degassing: FORMAT_A3,
	diskDiameter: FORMAT_N5_4,
	diskDiameterUnit: FORMAT_A3,
	earingRequested: FORMAT_A1,
	edgeShapeSpecification: FORMAT_A3,
	edgeSlitMarking: FORMAT_A1,
	edgeTrimmedInLastToolCode: FORMAT_A3,
	elongationMaxValue: FORMAT_N2,
	elongationMinValue: FORMAT_N2,
	embossingCodeBottom: FORMAT_A3,
	embossingCodeTop: FORMAT_A3,
	endUserIdentificationCoded: FORMAT_A10,
	expansionRateCalculated: FORMAT_N2_1,
	formingType: FORMAT_A3,
	furtherSurfaceProcessing: FORMAT_A3,
	grossWeightUnit: FORMAT_A3,
	hardnessType: FORMAT_A3,
	improvedCorrosionResistance: FORMAT_A3,
	inquiryNumber: FORMAT_A10,
	insideDiameterAlternativCode: FORMAT_A3,
	insideDiameterCode: FORMAT_A3,
	insulationResistanceTestMinValue: FORMAT_N5_1,
	insulationResistanceTestStandardName: FORMAT_A17,
	insulationResistanceTestUnit: FORMAT_A1,
	interruptionAllowance: FORMAT_A3,
	interruptionIdentificationTypeCode: FORMAT_A3,
	lengthToleranceMinus: FORMAT_N5_4,
	lengthTolerancePlus: FORMAT_N5_4,
	lengthToleranceUnit: FORMAT_A3,
	lengthUnit: FORMAT_A3,
	lengthValue: FORMAT_N5_4,
	lengthValueUS: FORMAT_A9,
	markingRequirementBottom: FORMAT_A1,
	markingRequirementTop: FORMAT_A1,
	maxBundleHeight: FORMAT_N5_4,
	maxBundleWeight: FORMAT_N5_4,
	maxGrossWeightValue: FORMAT_N5_4,
	maxHardnessValue: FORMAT_N3,
	maxInterruptionNumber: FORMAT_A3,
	maxiPressureSpecificationCustomerArticle: FORMAT_A3,
	maxNetWeightValue: FORMAT_N5_4,
	maxNumberOfSheetPerBundle: FORMAT_N4,
	maxNumberOfSlitCoilsPerPackage: FORMAT_N2,
	maxOutsideDiameter: FORMAT_N5_4,
	maxWeightPerWidthUnitValue: FORMAT_N5_4,
	maxWeldLaserNumber: FORMAT_A3,
	maxWeldNumberAfterRolling: FORMAT_A3,
	maxWeldNumberBeforeRolling: FORMAT_A3,
	millCertificateType: FORMAT_A5,
	minBundleHeight: FORMAT_N5_4,
	minBundleWeight: FORMAT_N5_4,
	minCoilWeightInPercent: FORMAT_N2,
	minGrossWeightValue: FORMAT_N5_4,
	minHardnessValue: FORMAT_N3,
	minNetWeightValue: FORMAT_N5_4,
	minNumberOfSheetPerBundle: FORMAT_N4,
	minNumberOfSlitCoilsPerPackage: FORMAT_N2,
	minOutsideDiameter: FORMAT_N5_4,
	minWeightPerWidthUnitValue: FORMAT_N5_4,
	netWeightUnit: FORMAT_A3,
	nominalGlossValueBottom: FORMAT_N3,
	nominalGlossValueTop: FORMAT_N3,
	nominalThicknessValueBottom: FORMAT_N3_2,
	nominalThicknessValueTop: FORMAT_N3_2,
	normalising: FORMAT_A3,
	notchToughnessTestSampledirectionCode: FORMAT_A3,
	notchToughnessTestTemperature: FORMAT_N3,
	notchToughnessTestTemperatureUnit: FORMAT_A3,
	numberOfSheetPerBundle: FORMAT_N4,
	oilingStatus: FORMAT_A3,
	oilQuantityChoice1Code: FORMAT_A3,
	oilReferenceChoice1: FORMAT_A3,
	oilType: FORMAT_A3,
	outsideDiameterUnit: FORMAT_A3,
	packagingCode: FORMAT_A3,
	packagingHeightDimensionUnit: FORMAT_A3,
	packagingHeightMaximumValue: FORMAT_N5_4,
	packagingHeightMinimumValue: FORMAT_N5_4,
	packagingWithWrapping: FORMAT_A1,
	paintThicknessRangeBottomSide: FORMAT_A3,
	paintThicknessRangeTopSide: FORMAT_A3,
	palletType: FORMAT_A3,
	peripheralInspectionLevel: FORMAT_A6,
	primaryFurtherProcessing: FORMAT_A3,
	productCategoryCode: FORMAT_A3,
	productFormCode: FORMAT_A3,
	productSubCategoryCode: FORMAT_A3,
	productSubjectToRegulation: FORMAT_A3,
	referenceCuttingDesign: FORMAT_A30,
	shipToPartyCoded: FORMAT_A10,
	shotBlasting: FORMAT_A1,
	shotBlastingCleaningStandard: FORMAT_A3,
	shotBlastingSide: FORMAT_A1,
	skinPassProcessCode: FORMAT_A3,
	specialAptitudeTop: FORMAT_A3,
	staggeringCoiling: FORMAT_A1,
	standardForUltrasonicTests: FORMAT_A17,
	steelGradeChemicalContentUnit: FORMAT_A3,
	steelGradeChemicalElementCode: FORMAT_A3,
	steelGradeMaxContentValue: FORMAT_N5_4,
	steelGradeMinContentValue: FORMAT_N5_4,
	steelGradeName: FORMAT_A17,
	steelGradeToCertifyNameID: FORMAT_A10,
	strippableFilmTypeBottom: FORMAT_A3,
	strippableFilmTypeTop: FORMAT_A3,
	surfaceInspectionLevel: FORMAT_A6,
	surfaceOrganicTextureBottom: FORMAT_A3,
	surfaceOrganicTextureTop: FORMAT_A3,
	thicknessToleranceMinus: FORMAT_N5_4,
	thicknessTolerancePlus: FORMAT_N5_4,
	thicknessToleranceUnit: FORMAT_A3,
	thicknessUnit: FORMAT_A3,
	thicknessValue: FORMAT_N5_4,
	threePiecesCanRollingDirection: FORMAT_A3,
	ultimateTensileStrengthMaxValue: FORMAT_N6,
	ultimateTensileStrengthMinValue: FORMAT_N6,
	ultrasonicTesting: FORMAT_A1,
	unwindingDirection: FORMAT_A1,
	use: FORMAT_A3,
	useOfWood: FORMAT_A3,
	userPartReference: FORMAT_A30,
	weldIdentificationAllowanceAfterRollingOrigin: FORMAT_A3,
	weldIdentificationTypeCodeAfterRolling: FORMAT_A3,
	weldLaserIdentificationTypeCode: FORMAT_A3,
	widthToleranceMinus: FORMAT_N5_4,
	widthTolerancePlus: FORMAT_N5_4,
	widthToleranceUnit: FORMAT_A3,
	widthUnit: FORMAT_A3,
	widthValue: FORMAT_N5_4,
	widthValueUS: FORMAT_A9,
	yieldFactorWeightConversion: FORMAT_N5_4,
	yieldStrengthMaxValue: FORMAT_N6,
	yieldStrengthMinValue: FORMAT_N6
};

const FIELD_UNIT: Record<string, string> = {
	aimedThickness: 'thicknessUnit',
	diskDiameter: 'diskDiameterUnit',
	insulationResistanceTestMinValue: 'insulationResistanceTestUnit',
	lengthToleranceMinus: 'lengthToleranceUnit',
	lengthTolerancePlus: 'lengthToleranceUnit',
	lengthValue: 'lengthUnit',
	lengthValueUS: 'lengthUnit',
	maxGrossWeightValue: 'grossWeightUnit',
	maxNetWeightValue: 'netWeightUnit',
	maxOutsideDiameter: 'outsideDiameterUnit',
	minGrossWeightValue: 'grossWeightUnit',
	minNetWeightValue: 'netWeightUnit',
	minOutsideDiameter: 'outsideDiameterUnit',
	notchToughnessTestTemperature: 'notchToughnessTestTemperatureUnit',
	packagingHeightMaximumValue: 'packagingHeightDimensionUnit',
	packagingHeightMinimumValue: 'packagingHeightDimensionUnit',
	steelGradeMaxContentValue: 'steelGradeChemicalContentUnit',
	steelGradeMinContentValue: 'steelGradeChemicalContentUnit',
	thicknessToleranceMinus: 'thicknessToleranceUnit',
	thicknessTolerancePlus: 'thicknessToleranceUnit',
	thicknessValue: 'thicknessUnit',
	widthToleranceMinus: 'widthToleranceUnit',
	widthTolerancePlus: 'widthToleranceUnit',
	widthValue: 'widthUnit'
};

const FIELD_LIST_UNIT = new Set([
	'netWeightUnit',
	'thicknessToleranceUnit',
	'diskDiameterUnit',
	'widthUnit',
	'grossWeightUnit',
	'lengthUnit',
	'outsideDiameterUnit',
	'steelGradeChemicalContentUnit',
	'thicknessUnit',
	'insulationResistanceTestUnit',
	'widthToleranceUnit',
	'lengthToleranceUnit',
	'notchToughnessTestTemperatureUnit',
	'packagingHeightDimensionUnit'
]);

export function getFieldFormat(fieldName: string) {
	return fieldName in FORMAT_BY_FIELD ? FORMAT_BY_FIELD[fieldName] : undefined;
}

export function getFieldUnit(fieldName: string) {
	// name of the field acting as a unit
	return fieldName in FIELD_UNIT ? FIELD_UNIT[fieldName] : undefined;
}

export function isFieldUnit(fieldName: string) {
	return FIELD_LIST_UNIT.has(fieldName);
}
